import React, { useState } from 'react';
import NavBar from '../../components/navbar/NavBar';
import Footer from '../../components/footer/Footer';
import './contactStyle.css';
import profilePic from '../../assets/profilePic.gif';
import { IoLogoWechat } from "react-icons/io5";
import { MdOutlineEmail } from "react-icons/md";


const Contact = () => {
    // State for form fields and submission status (keep existing state)
    const [copiedText, setCopiedText] = useState(''); // State to track copied text


    // Function to handle copying text to clipboard
    const handleCopy = (textToCopy, type) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopiedText(type); // Set which text was copied
            setTimeout(() => setCopiedText(''), 2000); // Clear the message after 2 seconds
        }).catch(err => {
            console.error('Failed to copy text: ', err);
            // You might want to show an error message to the user here
        });
    };

    return (
        <div className="contact-page">
            <NavBar />
            <div className="contact-container">
                <div className="profile-picture-container">
                    <img src={profilePic} alt="我的头像 (My Avatar)" className="profile-picture" />
                </div>

                <h1>联系我</h1>
                <p className="contact-intro">
                    如果您有任何问题、建议或合作意向，欢迎通过以下方式与我联系。
                </p>

                <div className="contact-info">
                    <div className="contact-item">
                        <IoLogoWechat className="contact-icon" />
                        <span className="contact-label">微信：</span>
                        <span
                            className="contact-value copyable"
                            onClick={() => handleCopy('NoahWang2003', 'wechat')}
                        >
                            NoahWang2003
                            {copiedText === 'wechat' && <span className="copied-feedback"> 已复制!</span>}
                        </span>
                    </div>
                    <div className="contact-item">
                        <MdOutlineEmail className="contact-icon" />
                        <span className="contact-label">邮箱：</span>
                        <span
                            className="contact-value copyable"
                            onClick={() => handleCopy('893898956wrz@gmail.com', 'email')}
                        >
                            893898956wrz@gmail.com
                            {copiedText === 'email' && <span className="copied-feedback"> 已复制!</span>}
                        </span>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
};

export default Contact; 